import { FilterItem } from './filter.item';
import { FilterItemProps } from './interfaces/filter.item.props';
import { FilterTypeEnum } from './enum/filter.type.enum';

export class FilterSelectItem extends FilterItem {
  constructor(props: Omit<FilterItemProps, 'type'>) {
    super({ ...props, type: FilterTypeEnum.SELECT });
    this.defaultValue = props.multiple ? [] : 'null';
  }
}